module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "tabs-horizon tabs-horizon-flex",
    class: ['tabs-horizon-' + _vm.theme]
  }, _vm._l((_vm.surface), function(item, index) {
    return _c('button', {
      staticClass: "tabs-item",
      class: [
        item.alias == _vm.current ? 'tabs-item-current' : ''
      ],
      on: {
        "click": function($event) {
          _vm.handleClick(item, index)
        }
      }
    }, [_vm._v("\n     " + _vm._s(item.title) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a1598b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tabs.vue
// module id = 262
// module chunks = 26